module.exports = __webpack_public_path__ + "img/UHF-DVS-25.2a7e3a22.png";